// extracted by mini-css-extract-plugin
module.exports = {"Profile":"Profile--1APM-","Cow":"Cow--1Ori-","Tag":"Tag--QHAOR"};